import { useIsNotRedirectOnCatalog, usePrescriptionForm, usePrescriptionNumbers } from '@entities/prescription/hooks'
import styled from 'styled-components'
import React from 'react'
import { InputFormDesktop, InputType } from 'src/shared/ui/desktop/form/input-desktop'
import { prescriptionEnterForm, prescriptionEnterSubmitFx } from '@entities/prescription/model'
import { ModalDefaultDesktop } from 'src/shared/ui/modals/modal-default-desktop'
import Button from '@shared/Button/Button'
import * as Theme from '@styles/theme-const'
import { useStore } from 'effector-react'

const Form = styled.form`
    max-height: 600px;
    overflow: auto;
    max-width: 674px;
`
const FormContainer = styled.div`
    display: flex;
`
const Description = styled.div`
    font-size: 16px;
    white-space: pre-line;
    width: 179px;
    padding: 0 1rem;
    text-align: left;
`
const InputsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 400px;
`
export const PrescriptionEnterFormDesktop = () => {
    const form = usePrescriptionForm()
    const isLoading = useStore(prescriptionEnterSubmitFx.pending)
    const prescriptionNumbers = usePrescriptionNumbers()
    const isNotRedirectOnCatalog = useIsNotRedirectOnCatalog()

    return (
        <Form onSubmit={form.handleSubmit}>
            <FormContainer>
                <InputsContainer>
                    <InputFormDesktop
                        label={'ФИО'}
                        controller={form.controller({
                            name: prescriptionEnterForm.getName('fullName')
                        })}
                        attributes={{
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            placeholder: 'Фамилия Имя Отчество'
                        }}
                        dataInputName={'fullName'}
                    />
                    <InputFormDesktop
                        label={'Дата рождения'}
                        dataInputName={'fullName'}
                        inputType={InputType.date}
                        controller={form.controller({
                            name: prescriptionEnterForm.getName('birthday')
                        })}
                        attributes={{
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            placeholder: '01.01.2000'
                        }}
                    />
                    {prescriptionNumbers.map((x) => (
                        <InputFormDesktop
                            key={x}
                            //isDisabledElseEmpty={x !== '0'}
                            label={'Номер рецепта'}
                            inputType={InputType.default}
                            controller={form.controller({
                                name: prescriptionEnterForm.getName('prescriptionNumbers', x)
                            })}
                            attributes={{
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                placeholder: x === '0' ? '01N1243567890' : 'Дополнительный рецепт'
                            }}
                            dataInputName={`prescriptionNumbers.${x}`}
                        />
                    ))}
                    <Button
                        type="submit"
                        data-submit-prescription-enter
                        disabled={isLoading}
                        elementSizeTypeValue={Theme.ElementSizeType.large}>
                        {isNotRedirectOnCatalog ? 'Ввести рецепт' : 'Найти товары по рецепту'}
                    </Button>
                </InputsContainer>
                <Description>
                    Введите ваши данные, чтобы мы могли узнать, какие товары по рецепту вам доступны для доставки
                </Description>
            </FormContainer>
        </Form>
    )
}

export const ModalPrescriptionDesktop = ({
    cancelHandler,
    isOpened = false
}: {
    cancelHandler: () => void
    isOpened: boolean
}) => {
    return (
        <ModalDefaultDesktop closeHandler={cancelHandler} isOpened={isOpened} modalName={'erecipe'}>
            <PrescriptionEnterFormDesktop />
        </ModalDefaultDesktop>
    )
}
